export class UploadFile {
    public id: string;
    public isUploading: boolean;
    public isError: boolean;
    public errorMessage: string;
    public isSuccess: boolean;
    public progress: number;
    public response: any;
    public file: any;
    public remove: any;
    public size: number;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/UploadFile.ts